import loadable from 'components/dynamic-import';

const Powers = loadable(() => import('./Powers'));

export { Powers };
